import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useKeycloak } from "./KeycloakContext";
import { login } from "../redux/actions/LoginActions";

/**
 * When the user is on a protected page (not signin) with Keycloak authenticated
 * but no backend token, run LoadUserData once so the session "charges" automatically
 * without requiring a manual Logout or visit to the SignIn page.
 */
const KeycloakSessionSync = () => {
  const { userAuthenticated, userInfo } = useKeycloak();
  const location = useLocation();
  const dispatch = useDispatch();
  const token = useSelector((state) => state.login?.token);
  const user = useSelector((state) => state.user);
  const loginSuccess = useSelector((state) => state.login?.success);
  const loginLoading = useSelector((state) => state.login?.loading);
  const syncedRef = useRef(false);

  useEffect(() => {
    const pathname = location.pathname;
    const isSessionRoute =
      pathname === "/session/signin" || pathname === "/session/404";
    if (isSessionRoute) return;

    if (!userAuthenticated || !userInfo?.username || !userInfo?.token) return;
    if (loginLoading || loginSuccess) return;
    if (syncedRef.current) return;

    const hasToken = token != null && token !== "";
    const hasUser = user && Object.keys(user).length > 0;
    const tokenExpired =
      user?.exp && Date.now() > user.exp * 1000;
    if (hasToken && hasUser && !tokenExpired) return;

    syncedRef.current = true;
    dispatch(
      login({ loginUser: userInfo.username, token: userInfo.token })
    );
  }, [
    userAuthenticated,
    userInfo?.username,
    userInfo?.token,
    token,
    user,
    loginLoading,
    loginSuccess,
    location.pathname,
    dispatch,
  ]);

  return null;
};

export default KeycloakSessionSync;
